import { useState } from "react";
import './IconSetTest.scss';

// FontAwesome Icons
import { 
    FaCheckCircle, 
    FaShieldAlt, 
    FaLeaf, 
    FaTruck, 
    FaHeadset, 
    FaGift 
} from "react-icons/fa";

// Material Design Icons
import { 
    MdVerified, 
    MdSecurity, 
    MdEco, 
    MdLocalShipping, 
    MdSupportAgent, 
    MdCardGiftcard 
} from "react-icons/md";

// Bootstrap Icons
import { 
    BsCheckCircleFill, 
    BsShieldCheck, 
    BsTree, 
    BsTruck, 
    BsHeadset, 
    BsGift 
} from "react-icons/bs";

// Heroicons
import { 
    HiCheckCircle, 
    HiShieldCheck, 
    HiSparkles, 
    HiTruck, 
    HiSupport, 
    HiGift 
} from "react-icons/hi";

// Ionicons
import { 
    IoCheckmarkCircle, 
    IoShieldCheckmark, 
    IoLeaf, 
    IoCar, 
    IoCall, 
    IoGift 
} from "react-icons/io5";

// Feather Icons
import { 
    FiCheckCircle, 
    FiShield, 
    FiZap, 
    FiTruck, 
    FiHelpCircle, 
    FiAward 
} from "react-icons/fi";

// Ant Design Icons
import { 
    AiFillCheckCircle, 
    AiFillSafetyCertificate, 
    AiFillThunderbolt, 
    AiFillCar, 
    AiFillCustomerService, 
    AiFillGift 
} from "react-icons/ai";

// Remix Icons
import { 
    RiCheckboxCircleFill, 
    RiShieldCheckFill, 
    RiPlantFill, 
    RiTruckFill, 
    RiCustomerService2Fill, 
    RiGiftFill 
} from "react-icons/ri";

// Simple Icons
import { 
    SiCheckmarx, 
    SiHackthebox, 
    SiOpensourceinitiative, 
    SiFedex, 
    SiZendesk, 
    SiAmazon 
} from "react-icons/si";

export function IconSetTest() {
    const iconSets = [
        {
            name: "FontAwesome",
            icons: {
                quality: FaCheckCircle,
                payment: FaShieldAlt,
                eco: FaLeaf,
                delivery: FaTruck,
                support: FaHeadset,
                rewards: FaGift
            }
        },
        {
            name: "Material Design",
            icons: {
                quality: MdVerified,
                payment: MdSecurity,
                eco: MdEco,
                delivery: MdLocalShipping,
                support: MdSupportAgent,
                rewards: MdCardGiftcard
            }
        },
        {
            name: "Bootstrap Icons",
            icons: {
                quality: BsCheckCircleFill,
                payment: BsShieldCheck,
                eco: BsTree,
                delivery: BsTruck,
                support: BsHeadset,
                rewards: BsGift
            }
        },
        {
            name: "Heroicons",
            icons: {
                quality: HiCheckCircle,
                payment: HiShieldCheck,
                eco: HiSparkles,
                delivery: HiTruck,
                support: HiSupport,
                rewards: HiGift
            }
        },
        {
            name: "Ionicons",
            icons: {
                quality: IoCheckmarkCircle,
                payment: IoShieldCheckmark,
                eco: IoLeaf,
                delivery: IoCar,
                support: IoCall,
                rewards: IoGift
            }
        },
        {
            name: "Feather Icons",
            icons: {
                quality: FiCheckCircle,
                payment: FiShield,
                eco: FiZap,
                delivery: FiTruck,
                support: FiHelpCircle,
                rewards: FiAward
            }
        },
        {
            name: "Ant Design Icons",
            icons: {
                quality: AiFillCheckCircle,
                payment: AiFillSafetyCertificate,
                eco: AiFillThunderbolt,
                delivery: AiFillCar,
                support: AiFillCustomerService,
                rewards: AiFillGift
            }
        },
        {
            name: "Remix Icons",
            icons: {
                quality: RiCheckboxCircleFill,
                payment: RiShieldCheckFill,
                eco: RiPlantFill,
                delivery: RiTruckFill,
                support: RiCustomerService2Fill,
                rewards: RiGiftFill
            }
        },
        {
            name: "Simple Icons",
            icons: {
                quality: SiCheckmarx,
                payment: SiHackthebox,
                eco: SiOpensourceinitiative,
                delivery: SiFedex,
                support: SiZendesk,
                rewards: SiAmazon
            }
        }
    ];

    const features = [
        { text: "Assured On Quality", key: "quality" },
        { text: "Secure Payment Options", key: "payment" },
        { text: "Eco-Friendly Practices", key: "eco" },
        { text: "Fast Delivery Options", key: "delivery" },
        { text: "Customer Support", key: "support" },
        { text: "Loyalty Rewards", key: "rewards" }
    ];

    return (
        <div className="icon-set-test-page">
            <h1 className="page-title">Icon Set Variations for Product Features</h1>
            <p className="page-subtitle">Choose your preferred icon style for each feature type</p>

            {features.map((feature, featureIndex) => (
                <div key={featureIndex} className="feature-section">
                    <h2 className="feature-title">{feature.text}</h2>
                    <div className="icon-sets-grid">
                        {iconSets.map((iconSet, setIndex) => {
                            const IconComponent = iconSet.icons[feature.key];
                            return (
                                <div key={setIndex} className="icon-set-card">
                                    <div className="icon-set-name">{iconSet.name}</div>
                                    <div className="icon-display">
                                        <IconComponent className="feature-icon" />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
}

